import { gql, useQuery } from "@apollo/client";
import { ReactNode } from "react";
import { useStoreContext } from "../../contexts/StoreProvider";
import Loader from "../Loader";
import styles from "./index.module.scss";

const GET_EXTERNAL_URLS = gql`
  query GetExternalUrls {
    externalLink {
      data {
        id
        attributes {
          mobility_devices_policy_and_administration_manual
          mobility_devices_product_manual
          motion_accessibility_policy
          motion_privacy_policy
          ontario_gov_adp_form_downloads
        }
      }
    }
  }
`;

const AppWrapper = ({ children }: { children: ReactNode | ReactNode[] }) => {
  const { dispatch } = useStoreContext();

  const { loading } = useQuery(GET_EXTERNAL_URLS, {
    onCompleted: (data) => {
      dispatch({
        type: "UPDATE_EXTERNAL_URLS",
        payload: data.externalLink?.data?.attributes ?? data.externalLink,
      });
    },
  });

  if (loading) {
    return <Loader heading="Loading..." className={styles.loader} />;
  }
  return <>{children}</>;
};

export default AppWrapper;
